import React from 'react';
export function TrustBar() {
  const partners = [{
    name: 'Moon Palace Cancun',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bTgHz94H979P6PYRZ9jfjH/WhatsApp_Image_2025-10-14_at_02.04.57.jpg'
  }, {
    name: 'AIC Hotel Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nnRUkziNxnhk5RQqAT5dwy/WhatsApp_Image_2025-10-14_at_02.04.56.jpg'
  }, {
    name: 'Playa Hotels & Resorts',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sUgc6eSCDxrQGXbUMNJB5Z/WhatsApp_Image_2025-10-14_at_02.04.57_%281%29.jpg'
  }, {
    name: 'Hyatt',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2Zzfpffnq6KYpT5vGp45ZW/WhatsApp_Image_2025-10-14_at_02.04.57_%282%29.jpg'
  }, {
    name: 'Lomas Travel',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bnr3MgQ8AJBDx12nwbQNDX/WhatsApp_Image_2025-10-14_at_02.04.56_%282%29.jpg'
  }, {
    name: 'Palladium Hotel Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kSVkKmXp2LF3DnAoiPYXZA/WhatsApp_Image_2025-10-14_at_02.04.56_%281%29.jpg'
  }];
  // Duplicate partners array for seamless loop
  const allPartners = [...partners, ...partners];
  return <section className="py-12 bg-white overflow-hidden" data-id="element-271">
      <div className="container mx-auto px-4 md:px-6" data-id="element-272">
        <h2 className="text-center text-lg font-medium text-[#374047]/70 mb-10" data-id="element-273">
          Trusted by Leading Resort and Production Partners
        </h2>

        {/* Horizontal Scrolling Logo Ticker */}
        <div className="relative" data-id="element-274">
          <div className="flex animate-scroll" data-id="element-275">
            {allPartners.map((partner, index) => <div key={index} className="flex-shrink-0 mx-8 flex items-center justify-center" data-id="element-276">
                <img src={partner.logo} alt={partner.name} className="h-16 w-auto object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300" data-id="element-277" />
              </div>)}
          </div>
        </div>
      </div>

      <style data-id="element-278">{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}